import api from "./api";

export const getNotifications = (page = 1) =>
  api.get("/notifications", { params: { page } }).then((res) => res.data);

export const markNotificationRead = (id) =>
  api.post(`/notifications/${id}/read`).then((res) => res.data);

export const markAllNotificationsRead = () =>
  api.post("/notifications/read-all").then((res) => res.data);
